import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IArtDetails {
  artName?: string;
  artistName?: string;
  artMedium?: string;
  artPrice?: string;
  artSize?: string;
  artCreationDate?: string;
  artAvailable?: string;
  artImage?: string;
}

interface ArtDetailsState {
  isVisible: boolean;
  artData: IArtDetails | null;
}

const initialState: ArtDetailsState = {
  isVisible: false,
  artData: null,
};

const artDetailsSlice = createSlice({
  name: "ArtDetailsVisibility",
  initialState,
  reducers: {
    showArtDetails(state, action: PayloadAction<IArtDetails>) {
      state.isVisible = true;
      state.artData = action.payload;
    },
    hideArtDetails(state) {
      state.isVisible = false;
      state.artData = null;
    },
  },
});

export const { showArtDetails, hideArtDetails } = artDetailsSlice.actions;
export default artDetailsSlice.reducer;
